/**
 * Filtro de búsqueda por texto - V05.1
 * PTEL - Sistema de Normalización de Coordenadas
 */

import React, { memo, useState, useEffect, useCallback } from 'react';
import { Input } from '../../ui/input';
import { Search, X } from 'lucide-react';

export interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

export const SearchFilter = memo<SearchFilterProps>(function SearchFilter({
  value,
  onChange,
  placeholder = 'Buscar infraestructura...',
  debounceMs = 300,
}) {
  const [localValue, setLocalValue] = useState(value);

  // Sincronizar con valor externo
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // Debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue);
      }
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [localValue, value, onChange, debounceMs]);

  const handleClear = useCallback(() => {
    setLocalValue('');
    onChange('');
  }, [onChange]);

  return (
    <div className="ptel-search-filter">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-500" />
        <Input
          type="text"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          placeholder={placeholder}
          className="pl-9 pr-9 bg-stone-800 border-stone-700 text-stone-100 placeholder:text-stone-500"
        />
        {localValue && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-500 hover:text-stone-300"
            aria-label="Limpiar búsqueda"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
});

export default SearchFilter;
